import React from 'react';
import { ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from 'recharts';

export const fmtDay = (iso, opts = { day: 'numeric', month: 'short' }) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('es-MX', { timeZone: 'UTC', ...opts });
};

const Tip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div className="rounded-lg border border-gray-700 bg-gray-950/95 px-3 py-2 text-xs shadow-xl">
      <p className="text-gray-400 mb-1">{fmtDay(label, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })}</p>
      <p className="text-white font-semibold">{p.count} búsqueda{p.count === 1 ? '' : 's'}</p>
      <p className="text-rose-300">{p.zero_results} sin resultados</p>
    </div>
  );
};

export const DailySearchChart = ({ data, height = 260, testid = 'daily-search-chart' }) => (
  <div style={{ height }} data-testid={testid}>
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
        <CartesianGrid stroke="rgba(255,255,255,0.06)" vertical={false} />
        <XAxis dataKey="date" tickFormatter={d => fmtDay(d)} tick={{ fill: '#9ca3af', fontSize: 11 }} axisLine={false} tickLine={false} minTickGap={20} />
        <YAxis allowDecimals={false} tick={{ fill: '#9ca3af', fontSize: 11 }} axisLine={false} tickLine={false} />
        <Tooltip content={<Tip />} cursor={{ fill: 'rgba(249,115,22,0.08)' }} />
        <Legend wrapperStyle={{ fontSize: 11, color: '#9ca3af' }} formatter={v => (v === 'count' ? 'Búsquedas' : 'Sin resultados')} />
        <Bar dataKey="count" fill="#f97316" radius={[4, 4, 0, 0]} maxBarSize={28} />
        <Line dataKey="zero_results" type="monotone" stroke="#fb7185" strokeWidth={2} dot={false} />
      </ComposedChart>
    </ResponsiveContainer>
  </div>
);
